import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import axios from "axios";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageFour from "./PageFour";
import LoadingPage from "./LoadingPage";
// import jsonFile from "./rpt-pmt-hasilAsesmen.json";

const PageThree = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [subProfilList, SetSubProfilList] = useState([]);
    const [pageAssesment, SetPageAssesment] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_THREE, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Two", error);
                });

            if (response) {
                if (response.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Three ", responseAPI);
                    console.log("====================================");

                    SetSubProfilList(responseAPI.subProfilList);
                    SetPageAssesment(responseAPI.listResponseDetailAsessment);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            {pageAssesment.map((listPage, a) => {
                return (
                    <div key={a}>
                        <div className="report-page">
                            <div className="cardLine">
                                {/* header */}
                                <div className="pnl-header">
                                    <div className="card-page">
                                        <span style={{
                                            fontSize: '26px',
                                            color: '#FFF',
                                            fontWeight: 500,
                                            fontFamily: 'lucida grande'
                                        }}>05</span>
                                    </div>
                                    <div className="pnl-date">
                                        https://eduprime.co.id/
                                    </div>
                                </div>
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                    <div>
                                        <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik </span>
                                        <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center',}}>
                                        <div className="label-sub-tit">
                                            <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '3%' }}>
                                    <div>
                                        <span className="title-header2" style={{ color: '#015E56', fontSize: '20px', }}>Rekapitulasi Pemetaan Kurikulum Merdeka Belajar </span>
                                        <p style={{ color: '#015E56', fontSize: '16px', fontWeight: '500', marginTop: '10px' }}>Berdasarkan Placement</p>
                                    </div>
                                    <div>
                                        <div className="label-sub-tit" style={{ backgroundColor: '#0097CE' }}>
                                            <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>{listPage.namaJurusan}</span>
                                        </div>
                                    </div>
                                </div>
                                <Gap height={20} />
                                <div className="rekap-table">
                                    <table style={{ fontSize: 16, width: "100%" }}>
                                        <thead style={{ backgroundColor: "#BEF264", fontSize: 17, textAlign: "center" }}>
                                            <tr>
                                                <th
                                                    width="200"
                                                    height="50"
                                                    colSpan={2}
                                                    style={{
                                                        textAlign: "left",
                                                        paddingLeft: 15,
                                                    }}
                                                >
                                                    Nama Siswa
                                                </th>
                                                {subProfilList.map((detailMapel, i) => {
                                                    return (
                                                        <th key={i}
                                                            style={
                                                                i % 2 === 0
                                                                    ? {
                                                                        color: "#212529",
                                                                    }
                                                                    : {
                                                                        color: "#80858a",
                                                                    }
                                                            }
                                                        >
                                                            {detailMapel.deskripsi}
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listPage.detailSiswa.map((siswa, b) => {
                                                return (
                                                    <>
                                                        <tr key={b}
                                                            width="100%"
                                                            height="40"
                                                            style={
                                                                b % 2 === 0
                                                                    ? {
                                                                        backgroundColor: "#F8F9FA",
                                                                        textAlign: "center",
                                                                    }
                                                                    : {
                                                                        backgroundColor: "#dcddde",
                                                                        textAlign: "center",
                                                                    }
                                                            }
                                                        >
                                                            <td>{b + 1}</td>
                                                            <td
                                                                width="200"
                                                                style={{
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {siswa.namaSiswa}
                                                            </td>
                                                            {siswa.listAsessment.map((score, d) => {
                                                                return (
                                                                    <>
                                                                        {score.akademik ? (
                                                                            <td key={d}
                                                                                style={
                                                                                    d % 2 === 0
                                                                                        ? {
                                                                                            color: "#212529",
                                                                                        }
                                                                                        : {
                                                                                            color: "#80858a",
                                                                                        }
                                                                                }
                                                                            >
                                                                                {score.skor}
                                                                            </td>
                                                                        ) : (
                                                                            <td
                                                                                style={
                                                                                    d % 2 === 0
                                                                                        ? {
                                                                                            color: "#212529",
                                                                                        }
                                                                                        : {
                                                                                            color: "#80858a",
                                                                                        }
                                                                                }
                                                                            >
                                                                                {score.singkatan}
                                                                            </td>
                                                                        )}
                                                                    </>
                                                                );
                                                            })}
                                                        </tr>
                                                    </>
                                                );
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td>
                                                    <div className="pagebreak-footer"></div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <Gap height={20} />
                        </div>
                    </div>
                );
            })}

            {openPage ? <PageFour idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
        </div>
    );
};

export default PageThree;
